export default {
  inherit: {
    color: "inherit",
  },
};
